import { useEffect, useState } from 'react';
import { BannerData } from '../lib/bannerData';
import { BANNER_CONFIG } from '../lib/constants';

interface BannerImageProps {
  currentBanner: BannerData;
}

const BannerImage = ({ currentBanner }: BannerImageProps) => {
  const [displayImage, setDisplayImage] = useState(currentBanner.imageUrl);
  const [nextImage, setNextImage] = useState(currentBanner.imageUrl);
  const [isImageAnimating, setIsImageAnimating] = useState(false);

  useEffect(() => {
    if (displayImage !== currentBanner.imageUrl) {
      setNextImage(currentBanner.imageUrl);
      setIsImageAnimating(true);

      setTimeout(() => {
        setDisplayImage(currentBanner.imageUrl);
        setIsImageAnimating(false);
      }, BANNER_CONFIG.IMAGE_TRANSITION_DELAY);
    }
  }, [currentBanner.imageUrl, displayImage]);

  const getImageClasses = (isNext = false) => {
    const baseClasses = 'absolute top-0 left-0 h-full w-full rounded-[12px] object-cover';

    if (isNext) {
      return `${baseClasses} ${isImageAnimating ? 'slide-in-right' : 'translate-x-[100px] opacity-0'}`;
    }

    return `${baseClasses} ${isImageAnimating ? 'slide-out-left' : 'translate-x-0 opacity-100'}`;
  };

  const getImageStyle = () => ({
    transition: isImageAnimating ? 'none' : 'all 0.3s ease',
  });

  return (
    <div className='relative desktop:h-[320px] h-[180px] w-full desktop:max-w-[500px] overflow-hidden rounded-[12px] sm:h-[280px] md:h-[572px]'>
      <img src={displayImage} alt={currentBanner.imageAlt} className={getImageClasses()} style={getImageStyle()} />
      <img src={nextImage} alt={currentBanner.imageAlt} className={getImageClasses(true)} style={getImageStyle()} />
    </div>
  );
};

export default BannerImage;
